<template>
  <section class="container">
    <Alerts />
    <!-- ======= TextEditor Section ======= -->

    <!-- End TextEditor -->

    <div class="col-sm-12">
      <div class="contentManagement">
        <!-- <h4>مدیریت محتوا</h4> -->
        <div class="col-sm-6">
          <div class="input-group input-group-sm mb-3">
            <span class="input-group-text" id="inputGroup-sizing-sm"
              >انتخاب سرفصل</span
            >
            <v-select
            style="width: 80%;"
            dir="rtl"
            v-model="contentCategorySelected"
            :options="contentCategory"
            label="categoryTitle"
            @option:selected="getContentListByCategoryRef"
            :reduce="(c) => c.id"
          ></v-select>
          
          </div>

        
        </div>

        <hr />
        <div v-show="!hideGrid" class="col-sm-12">
          <DxDataGrid
            :show-row-lines="true"
            :show-column-lines="true"
            :row-alternation-enabled="true"
            :rtl-enabled="true"
            :data-source="contentListByCategoryRef"
            :columns="columnsFields"
            :remote-operations="true"
            :column-auto-width="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :hover-state-enabled="true"
            @toolbar-preparing="onToolbarPreparing($event)"
            :focused-row-enabled="true"
            @focused-row-changed="onFocusedRowChanged"
            @content-ready="contentReady"
            key-expr="id"
            id="ps_Table"
            :ref="dataGridRef"
            :height="400"
          >
            <!-- @selection-changed="onSelectionChanged"  -->
            <DxSearchPanel
              :visible="true"
              :width="240"
              placeholder="جستجو ..."
            />
            <template #btnGroup>
              <div>
                <button
                  class="btn btn-sm btn-outline-info me-1"
                  @click="addNewItem"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title=""
                >
                  <i class="bi bi-plus"></i>
                  افزودن عنوان جدید
                </button>

                <button
                  class="btn btn-sm btn-outline-info me-1"
                  @click="getContentListByCategoryRef"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="بارگذاری مجدد"
                >
                  <i class="bi bi-arrow-clockwise"></i>
                </button>
              </div>
            </template>
            <template #actions="{}">
              <div>
                <!-- <button
              type="button"
              class="btn btn-sm btn-outline-success me-1"
              title="ویرایش"
              @click="editUserModal(data)"
            >
              <i class="bi bi-pencil"></i>
            </button> -->
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger me-1"
                  title="حذف"
                  @click="deleteConfirm(data)"
                >
                  <i class="bi bi-trash"></i>
                </button>

                <!-- <button
              type="button"
              class="btn btn-sm btn-outline-warning me-1"
              title="تغییر وضعیت"
              @click="changeDiscountState(data)"
            >
              <i class="bi bi-arrow-repeat"></i>
            </button> -->
              </div>
            </template>
            <DxFilterRow :visible="true" />
            <DxLoadPanel :enabled="true" />
            <DxScrolling mode="virtual" />
          </DxDataGrid>
        </div>

        <hr />
        <div class="col-sm-12">
          <div class="col-sm-12">
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >عنوان</span
              >
              <input
                v-model="currentRowSelected.title"
                type="text"
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >تگ ها</span
              >
              <input
                v-model="currentRowSelected.tag"
                type="text"
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>


              <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                > توضیح مختصر</span
              >
              <input
                v-model="currentRowSelected.summary"
                type="text"
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>

            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckChecked"
                :checked="currentRowSelected.visible"
                v-model="currentRowSelected.visible"
              />
              <label class="form-check-label" for="flexSwitchCheckChecked"
                >نمایش</label
              >
            </div>
          </div>
          <div class="col-sm-6"></div>
          <div class="col-sm-6"></div>
        </div>
        <TextEditor />
        <div class="text-center">
          <br />
          <button class="btn btn-success" @click="addOrUpdateContent">
            <i class="bi bi-save"></i>
            ذخیره
          </button>
        </div>
        <!-- <button @click="setEditorValue">setEditorValue</button> -->
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import TextEditor from "@/components/TextEditor.vue";
import Alerts from "@/components/Alerts";
import { dataGridMixin } from "@/components/dataGridMixin";
import Swal from "sweetalert2";

export default {
  components: {
    TextEditor,
    Alerts,
  },
  mixins: [dataGridMixin],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      contentCategory: "controlPanelX/contentCategory",
      contentByCategoryRef: "controlPanelX/contentByCategoryRef",
      contentListByCategoryRef: "controlPanelX/contentListByCategoryRef",
    }),
  },
  data() {
    return {
      hideGrid: false,
      currentRowSelected: {},
      columnsFields: [
        {
          cellTemplate: "actions",
          caption: "عملیات",
          allowFiltering: false,
          allowSorting: false,
          width: 120,
          alignment: "center",
        },
        {
          dataField: "title",
          caption: "عنوان",
          dataType: "string",
        },
        {
          dataField: "visible",
          caption: "نمایش",
          dataType: "boolean",
          width: 120,
        },
        {
          dataField: "tag",
          caption: "تگ ها",
          dataType: "string",
          width: 300,
        },
        {
          dataField: "currentDate",
          caption: "تاریخ",
          dataType: "string",
          width: 130,
          cssClass: "ltr",
        },
      ],
      contentCategorySelected: null,
      user: null,
    };
  },
  watch: {
    currentUser() {
      if (this.currentUser != undefined) {
        this.loadData();
      }
    },
  },
  methods: {
    onFocusedRowChanged(e) {
      const data = e.row && e.row.data;
      if (data != undefined) {
        this.currentRowSelected = data;
        this.setEditorValue(data.des);
      }
    },
    //  onSelectionChanged(e) {
    //   //const currentSelectedRowKeys = e.currentSelectedRowKeys;
    //   //const currentDeselectedRowKeys = e.currentDeselectedRowKeys;
    //   const allSelectedRowKeys = e.selectedRowKeys;
    //   //const allSelectedRowsData = e.selectedRowsData;
    // },
    contentReady(e) {
      //this.rowCount = e.component.getDataSource()._totalCount;
    },
    deleteConfirm() {
      Swal.fire({
        title: "آیا مطمئن هستید؟",
        text: "رکورد مورد نظر حذف می شود!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "لغو",
        confirmButtonText: "بله ، حذف شود !",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch(
            "controlPanelX/deleteContent",
            this.currentRowSelected.id
          );
          setTimeout(() => {
            this.getContentListByCategoryRef();
            this.currentRowSelected = {};
          }, 1000);
        }
      });
    },
    addNewItem() {
      this.dataGrid.clearSelection();
      this.dataGrid.option("focusedRowIndex", -1);
      this.currentRowSelected = { id: 0 };
      this.setEditorValue(null);
      this.hideGrid = true;
    },
    async getContentListByCategoryRef() {
      this.hideGrid = false;
      await this.$store.dispatch(
        "controlPanelX/getContentListByCategoryRef",
        this.contentCategorySelected
      );
    },
    async getContentCategoryByRef() {
      await this.$store.dispatch(
        "controlPanelX/getContentByCategoryRef",
        this.contentCategorySelected
      );
      this.setEditorValue(this.contentByCategoryRef.des);
    },
    getEditorValue() {
      return document.getElementsByClassName("ql-editor")[0].innerHTML;
    },
    setEditorValue(content) {
      document.getElementsByClassName("ql-editor")[0].innerHTML = content;
    },
    async addOrUpdateContent() {
      var model = {
        id: this.currentRowSelected.id,
        categoryRef: this.contentCategorySelected,
        title: this.currentRowSelected.title,
        des: this.getEditorValue(),
        tag: this.currentRowSelected.tag,
        thumbnailImage: null,
        mainImage: null,
        visible: this.currentRowSelected.visible,
        summary : this.currentRowSelected.summary,
      };
      await this.$store.dispatch("controlPanelX/addOrUpdateContent", model);
      this.hideGrid = false;
      this.getContentListByCategoryRef();
    },
    loadData() {
      this.user = this.$store.state.currentUser;
    },
  },
  created() {
    this.$store.dispatch("controlPanelX/getContentCategory");
  },
  mounted() {},
};
</script>


<style scoped>
section {
  padding: 140px 0 !important;
}
</style>